import "@lottiefiles/lottie-player";
import Layout from '../Layout';
//2.Initialization

const layout=new Layout();